import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { HearingSegment } from '../court';
/**
 * A list of line item properties that can be modified
 */
export class ModifyLineItemProperties {
}
__decorate([
    Type(() => HearingSegment),
    __metadata("design:type", Object)
], ModifyLineItemProperties.prototype, "hearingSegments", void 0);
